import { useEffect, useState } from 'react';
import { ACSApi } from '../../../api';
import { useContainer } from '../../useContainer';
import { BranchWithUsersDto } from '../../../commonTypes/acs';

const useHttpGetBranchWithUsers = (branchId?: string) => {
    const acsApi: ACSApi = useContainer(ACSApi);

    const [branchWithUsers, setBranchWithUsers] = useState<BranchWithUsersDto>();
    const [isReady, setIsReady] = useState(false);
    const [isError, setIsError] = useState(false);

    const getBranchWithUsers = (branchId: string) => {
        const { exec, abort } = acsApi.getBranchWithUsers({
            params: { branchId },
            onSuccess: res => {
                setBranchWithUsers(res.body);
                setIsReady(true);
            },
            onError: () => {
                setIsError(true);
            },
        });

        exec();
        return abort;
    };

    useEffect(() => {
        if (branchId) getBranchWithUsers(branchId);
    }, []);

    return { branchWithUsers, isReady, isError };
};

export default useHttpGetBranchWithUsers;
